import { TableWidgetHelper } from './TableWidgetHelper.js';

/**
 * Адаптер владельца фильтра для таблицы
 */
class TableFilterAdapter {
    constructor(root) {
        this.root = root;
        // Контейнер для чипсов: сначала точечный, потом общий блок
        this.chipsHost = this.root.querySelector(".chips") ?? undefined;
        // Контейнер для бейджа-числа выбранных фильтров
        this.badgeHost =
            this.root.querySelector(".im-table-filterscount") ??
                undefined;
    }
    /** Применить фильтр: инициируем reload таблицы через jQuery imTable('reload', ...) */
    async apply() {
        TableWidgetHelper.reload(this.root);
    }
}

export { TableFilterAdapter };
